export const NewsConstantTableHeaders = [
  "news-picture",
  "news-date",
  "modify",
  "delete",
];
